






const reqCertVal = [ 
    {
        value: "S",
        text: "Required",
    },
    {
        value: "N",
        text: "Not Required",
    }
]

const relIndVal = [ 
    {
        value: "S",
        text: "Yes",
    },
    {
        value: "N",
        text: "No",
    }
]

const dispStatusVal = [ 
    {
        value: "P",
        text: "Pending Dispatch",
    },
    {
        value: "D",
        text: "Dispatched Without Levante",
    },
    {
        value: "L",
        text: "Dispatched With Levante",
    },
    {
        value: "A",
        text: "Voided",
    },
]

const accStatusVal = [ 
    {
        value: "PL",
        text: "Pending contraction",
    },
    {
        value: "CO",
        text: "Contracted",
    },
    {
        value: "NC",
        text: "Not contracted for amount Zero",
    },
    {
        value: "PC",
        text: "Deferred Contraction",
    },
    {
        value: "IT",
        text: "Fully Entered",
    },
    {
        value: "IP",
        text: "Partial Entry",
    },
    {
        value: "AN",
        text: "Import Cancelled",
    },
]

const operationCodePDCAmend = [
    {
        value: "2",
        text: "Modification of PDC ",
    }
]

const operationCodePDC = [
    {
        value: "1",
        text: "PDC Presentation ",
    }
]

const operationCodeFullSAD = [ 
    {
        value: "0",
        text: "Addmission of SAD",
    },
    {
        value: "3",
        text: "SAD Admission when modifying PDC",
    },
]

const responseCodes =
    [
        {
            value: "0",
            text: "Accepted",
        },
        {
            value: "9",
            text: "Rejected",
        }
    ] 

const circuitVal = [
    {
        value: "V",
        text: "Green",
    },
    {
        value: "N",
        text: "Orange",
    },
    {
        value: "R",
        text: "Red",
    },
    {
        value: "A",
        text: "Yellow",
    }
]

const AEScircuitVal = [
    {
        value: "V",
        text: "Green Circuit",
    },
    {
        value: "N",
        text: "Orange Circuit",
    },
    {
        value: "R",
        text: "Red Circuit",
    }    
]

const processIndicatorVal = [
    {
        value: "2",
        text: "Rejected",
    },
    {
        value: "3",
        text: "SAD message accepted as complementary to previous declaration incomplete of provisional value",
    },
    {
        value: "4",
        text: "Goods release, Green Circuit, (LEV)",
    },
    {
        value: "5",
        text: "Goods for Physical Examination, Red Circuit, (NUM)",
    },
    {
        value: "6",
        text: "Goods for documentary clearance, Orange Circuit, (NUM)",
    },
    {
        value: "P",
        text: "The declaration has been PRE-Accepted, it is considered as a PRE-DUA of export, due to the lack of a container on the premises.",
    },
]

const processTypeIdentificationVal = [
    {
        value: "0",
        text: "Printing of the accompanying document cannot and must not be carried out by Export (DAE) in any form",
    },
    {
        value: "1",
        text: "The declarant is not authorized to print the accompanying document (AAD) for its own programmes",
    }
]

const clearanceResultVal = [
    {
        value: "A1",
        text: "In accordance with",
    },
    {
        value: "A2",
        text: "Deemed compliant",
    }
]

const DMSCRE = {
    value: "DMSCRE",
    text: "DECLARATION CREATED"
},
DMSSENT =  {
    value: "DMSSENT",
    text: "DECLARATION SENT"
},
CONTRL =  {
    value: "CONTRL",
    text: "TECHNICAL ERRORS"
},
 DMSREJ = {
    value: "DMSREJ",
    text: "DECLARATION REJECTED"
},
 DMSACC = {
    value: "DMSACC",
    text: "DECLARATION ACCEPTED"
},
 DMSDOC = {
    value: "DMSDOC",
    text: "DOCUMENTS CONTROL"
},
 DMSCTL = {
    value: "DMSCTL",
    text: "PHYSICAL INSPECTION"
},
 DMSROG = {
    value: "DMSROG",
    text: "PROVISIONALLY RELEASED"
},
 DMSRES = {
    value: "DMSRES",
    text: "ENTRY ADJUSTED"
},
 DMSGER = {
    value: "DMSGER",
    text: "EXIT INFO REQUIRED"
},

DMSCLE = {
    value: "DMSCLE",
    text: "FINAL RELEASE"
},
DMSRCV =  {
    value: "DMSRCV",
    text: "DECLARATION RECEIVED"
},
DMSEOG = {
    value: "DMSEOG",
    text: "EXIT CONFIRMATION"
},
DMSINC = {
    value: "DMSINC",
    text: "SUPPLEMENT REQUIRED"
},
DMSEXT =  {
    value: "DMSEXT",
    text: "EXTERNAL HANDLING"
},
ALTSENT =  {
    value: "ALTSENT",
    text: "EXIT INFO SENT"
},
ALTREJ = {
    value: "ALTREJ",
    text: "EXIT INFO REJECTED"
},
ALTRCV = {
    value: "ALTRCV",
    text: "EXIT INFO RECIEVED"
},
ALTREQ = {
    value: "ALTREQ",
    text: "EXIT INFO DECISION"
},
CORRES =  {
    value: "CORRES",
    text: "AMENDMENT FINALISED"
},
CORSENT = {
    value: "CORSENT",
    text: "AMENDMENT REQUEST SENT"
},
CORREJ = {
    value: "CORREJ",
    text: "AMENDMENT REJECTED"
},
CORRCV = {
    value: "CORRCV",
    text: "AMENDMENT RECEIVED"
},
CORREQ = {
    value: "CORREQ",
    text: "AMENDMENT DECISION"
},
DMSINV = {
    value: "DMSINV",
    text: "DECLARATION CANCELLED"
},
INVSENT = {
    value: "INVSENT",
    text: "CANCEL REQUEST SENT"
},
INVREJ = {
    value: "INVREJ",
    text: "CANCELLATION REJECTED"
},
INVREQ = {
    value: "INVREQ",
    text: "CANCELLATION DECISION"
},
INVRCV = {
    value: "INVRCV",
    text: "CANCELLATION RECEIVED"
},
SUPRCV = {
    value: "SUPRCV",
    text: "SUPPLEMENT RECIEVED"
},
SUPREQ = {
    value: "SUPREQ",
    text: "SUPPLEMENT DECISION"
},
SUPREJ = {
    value: "SUPREJ",
    text: "SUPPLEMENT REJECTED"
},
SUPRES = {
    value: "SUPRES",
    text: "SUPPLEMENT ACCEPTED"
};

const nextCustomStates = (currentState) => {
    switch(currentState) {
        case "STATE_DMSCRE":
            return [];
        case "STATE_CONTRL":
            return [];    
        case "STATE_DMSSENT":
            return [CONTRL, DMSREJ, DMSACC];
        case "STATE_DMSREJ":
            return [DMSSENT];
        case "STATE_DMSACC":
            return [DMSROG, DMSCTL, DMSDOC, DMSCLE, DMSEXT];  
        case "STATE_DMSDOC":
            return [DMSROG, DMSCTL, DMSCLE, DMSEXT];
        case "STATE_DMSCTL":
            return [DMSROG, DMSCLE, DMSEXT];
        case "STATE_DMSROG":
            return [DMSCLE, DMSRES, DMSEOG, DMSGER, DMSINC, DMSINV, DMSEXT];
        case "STATE_DMSINC":
            return [DMSCLE, DMSINV, DMSEXT];
        case "STATE_DMSRES":
            return [DMSCLE, DMSINV, DMSEXT]; 
        case "STATE_DMSCLE":
            return [DMSEOG, DMSINV, DMSGER, DMSEXT];
        case "STATE_DMSGER":
            return [DMSINV, DMSGER, DMSEXT];
        case "STATE_DMSEOG":
            return [DMSCLE, DMSRES, DMSINC, DMSEXT];
        case "STATE_DMSEXT":
            return [];
        case "STATE_CORSENT":
            return [CONTRL, CORREJ, CORRCV];
        case "STATE_CORREJ":
            return [DMSACC, DMSDOC, DMSCTL];
        case "STATE_CORRCV":
            return [CORREQ, CORREJ];
        case "STATE_CORREQ":
            return [CORRES, CORREJ];
        case "STATE_CORRES":
            return [DMSACC, DMSDOC, DMSCTL];
        case "STATE_SUPSENT":
            return [CONTRL, SUPREJ, SUPRCV];
        case "STATE_SUPREJ":
            return [DMSCLE, DMSEOG, DMSGER, DMSINC];
        case "STATE_SUPRCV":
            return [SUPREQ, SUPREJ];
        case "STATE_SUPREQ":
            return [SUPRES, SUPREJ];
        case "STATE_SUPRES":
            return [DMSCLE];
        case "STATE_ALTSENT":
            return [CONTRL, ALTREJ, ALTRCV, DMSEOG, DMSINC, DMSINV, DMSEXT];
        case "STATE_ALTRCV":
            return [ALTREJ, ALTREQ, DMSEOG, DMSINV, DMSEXT];
        case "STATE_ALTREQ":
            return [ALTREJ, DMSEOG, DMSINV, DMSEXT]
        case "STATE_ALTREJ":
            return [DMSEOG, DMSINV, DMSEXT, DMSGER]
        case "STATE_INVSENT":
            return [CONTRL, INVREJ, INVRCV]
        case "STATE_INVREJ":
            return [INVSENT];
        case "STATE_INVRCV":
            return [INVREQ, INVREJ];
        case "STATE_INVREQ":
            return [DMSINV];
        default:
            return [];                                                                                                                    
    }
}





const statusCodeValDec = 
    [
        {
            value: "DMSCRE",
            text: "DECLARATION CREATED"
        },
        {
            value: "DMSSENT",
            text: "DECLARATION SENT"
        },
        {
            value: "CONTRL",
            text: "TECHNICAL ERRORS"
        },
        {
            value: "DMSREJ",
            text: "DECLARATION REJECTED"
        },
        {
            value: "DMSACC",
            text: "DECLARATION ACCEPTED"
        },
        {
            value: "DMSDOC",
            text: "DOCUMENTS CONTROL"
        },
        {
            value: "DMSCTL",
            text: "PHYSICAL INSPECTION"
        },
        {
            value: "DMSROG",
            text: "PROVISIONALLY RELEASED"
        },
        {
            value: "DMSRES",
            text: "ENTRY ADJUSTED"
        },
        {
            value: "DMSGER",
            text: "EXIT INFO REQUIRED"
        },
        
        {
            value: "DMSCLE",
            text: "FINAL RELEASE"
        },
        {
            value: "DMSRCV",
            text: "DECLARATION RECEIVED"
        },
        {
            value: "DMSEOG",
            text: "EXIT CONFIRMATION"
        },
        {
            value: "DMSINC",
            text: "SUPPLEMENT REQUIRED"
        },
        {
            value: "DMSEXT",
            text: "EXTERNAL HANDLING"
        },
        
    ]

const statusCodeValExt = 
[
    // {
    //     value: "ALTREM",
    //     text: "SEND EXIT INFO (REMINDER)"
    // },
    {
        value: "DMSGER",
        text: "EXIT INFO REQUIRED"
    },
    {
        value: "ALTSENT",
        text: "EXIT INFO SENT"
    },
    {
        value: "ALTREJ",
        text: "EXIT INFO REJECTED"
    },
    {
        value: "ALTRCV",
        text: "EXIT INFO REJECTED (REVIEVED)"
    },
    {
        value: "ALTREQ",
        text: "EXIT INFO DECISION"
    },
    {
        value: "DMSEOG",
        text: "EXIT CONFIRMATION"
    },
    {
        value: "DMSEXT",
        text: "EXTERNAL HANDLING"
    },
]
const statusCodeValCor = (currentState) => {
    if(currentState === 'STATE_INVREQ'){
        return [ 
            
        CONTRL = {
            value: "CONTRL",
            text: "TECHNICAL ERROR"
        },
        
        DMSINV = {
              value: "DMSINV",
              text: "CANCELLATION ACCEPTED"
          },
          INVREJ =  {
            value: "INVREJ",
            text: "CANCELLATION REJECTED"
        }]
    } 
    if(currentState === 'STATE_CORREQ'){
        return [
            {
                value: "CONTRL",
                text: "TECHNICAL ERROR"
            },
            {
              value: "CORRES",
              text: "AMENDMENT FINALISED"
          },
          {
            value: "CORREJ",
            text: "AMENDMENT REJECTED"
        }]
    } 
    if(currentState === 'STATE_ALTREQ'){
        return [
            {
                value: "CONTRL",
                text: "TECHNICAL ERROR"
            },
            {
              value: "DMSCLE",
              text: "FINAL RELEASE"
          },  
          {
            value: "ALTREJ",
            text: "EXT INFO REJECTED"
        }]
    } 
    if(currentState === 'STATE_SUPREQ'){
        return [
            {
                value: "CONTRL",
                text: "TECHNICAL ERROR"
            },
            {
              value: "SUPRES",
              text: "SUPPLIMENT FINALISED"
          },
          {
            value: "SUPREJ",
            text: "SUPPLIMENT REJECTED"
        }    
        ]
    }     
  if([ 'STATE_DMSACC', 'STATE_DMSROG', 'STATE_DMSRES', 'STATE_DMSCTL', 'STATE_DMSCLE'].includes(currentState)){
    return [
        {
            value: "CONTRL",
            text: "TECHNICAL ERROR"
        },
        {
            value: "DMSRES",
            text: "ENTRY ADJUSTED"
        },
        {
            value: "DMSGER",
            text: "EXIT INFO REQUIRED"
        },
        {
            value: "DMSROG",
            text: "PROVISIONALLY RELEASED"
        },
        {
            value: "DMSINC",
            text: "SUPPLEMENT REQUIRED"
        },
        {
            value: "DMSCTL",
            text: "PHYSICAL INSPECTION"
        },
        {
            value: "DMSCLE",
            text: "FINAL RELEASE"
        },
        {
            value: "DMSEOG",
            text: "EXIT CONFIRMATION"
        },
        {
            value: "DMSEXT",
            text: "EXTERNAL HANDLING"
        }
        
    ]
}
return [
    {
        value: "CONTRL",
        text: "TECHNICAL ERROR"
    },
    {
        value: "CORSENT",
        text: "AMENDMENT REQUEST SENT"
    },
    {
        value: "CORREJ",
        text: "AMENDMENT REJECTED"
    },
    {
        value: "CORRCV",
        text: "AMENDMENT RECEIVED"
    },
    {
        value: "CORREQ",
        text: "AMENDMENT DECISION"
    },
    {
        value: "DMSRES",
        text: "ENTRY ADJUSTED"
    },
    {
        value: "DMSEXT",
        text: "EXTERNAL HANDLING"
    },
]
}
const statusCodeValCan = 
[
    {
        value: "CONTRL",
        text: "TECHNICAL ERROR"
    },
    {
        value: "DMSINV",
        text: "DECLARATION CANCELLED"
    },
    {
        value: "INVSENT",
        text: "CANCEL REQUEST SENT"
    },
    {
        value: "INVREJ",
        text: "CANCELLATION REJECTED"
    },
    {
        value: "INVREQ",
        text: "CANCELLATION DECISION"
    },
    {
        value: "INVRCV",
        text: "CANCELLATION RECEIVED"
    },
    {
        value: "DMSEXT",
        text: "EXTERNAL HANDLING"
    },
]

const statusCodeValSup = 
[
    {
        value: "CONTRL",
        text: "TECHNICAL ERROR"
    },
    {
        value: "SUPRCV",
        text: "SUPPLEMENT RECIEVED"
    },
    {
        value: "SUPREQ",
        text: "SUPPLEMENT DECISION"
    },
    {
        value: "SUPREJ",
        text: "SUPPLEMENT REJECTED"
    },
    {
        value: "SUPRES",
        text: "SUPPLEMENT ACCEPTED"
    },
    {
        value: "DMSEXT",
        text: "EXTERNAL HANDLING"
    },
    {
        value: "DMSROG",
        text: "PROVISIONAL RELEASED"
    },
    {
        value: "DMSINC",
        text: "SUPPEMENT REQUIRED"
    },
    {
        value: "DMSGER",
        text: "SEND EXIT INFO REQUIRED"
    },
    {
        value: "DMSCLE",
        text: "FINAL RELEASE"
    },

]
  

export {
    reqCertVal,
    relIndVal,
    dispStatusVal,
    accStatusVal,
    operationCodeFullSAD,
    operationCodePDC,
    operationCodePDCAmend,
    responseCodes,
    circuitVal,
    AEScircuitVal,
    processIndicatorVal,
    processTypeIdentificationVal,
    clearanceResultVal,
    statusCodeValDec,
    statusCodeValExt,
    statusCodeValCan,
    statusCodeValSup,
    statusCodeValCor,
    nextCustomStates
}